module.exports = __webpack_public_path__ + "static/media/27OCHA9.9338fd47.jpg";